import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class FormatDateService {

  /** เดือนย่อภาษาไทย (index 0 = ม.ค.) — ไม่พึ่ง locale ของ moment กันปัญหา locale ไม่ถูกโหลด */
  private readonly thaiMonthsShort = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

  constructor() { }

  /** วันที่แบบไทยสั้น เช่น "8 ก.ค. 2569" (ปี พ.ศ. = ค.ศ. + 543) */
  month(date: any): string {
    const m = moment(date);
    if (!m.isValid()) return '';
    return `${m.date()} ${this.thaiMonthsShort[m.month()]} ${m.year() + 543}`;
  }

  time(date: any): string {
    const m = moment(date);
    return m.isValid() ? m.format('HH:mm') : '';
  }
}
